import { observer } from 'mobx-react-lite';
import HomeTab from './HomeTab';
import ProjectSection from './ProjectSection';

const HomeDashboard = observer(() => {
    return (
        <div className="px-[32px] pt-[32px] w-full">
            <HomeTab />
            <ProjectSection />
        </div>
    );
});

export default HomeDashboard;
